import React, { Component } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import 'antd/dist/antd.css';

import MenuItem from './components/MenuItem';
// import Readme from './Readme';
import BaseQueryExample from './BaseQueryExample';
import BaseManipulationExample from './BaseManipulationExample';
import ManipulationLoadersExample from './ManipulationLoadersExample';
import ListExample from './ListExample';
import ListHooksExample from './ListHooksExample';
import Example from './Example';
import './App.css';


const { Content, Footer, Sider } = Layout;

class App extends Component {
  render() {
    return (
      <HashRouter basename="/">
        <Layout>
          <Sider
            breakpoint="lg"
            collapsedWidth="0"
          >
            <div className="logo">
              <a href="https://github.com/Bizico/bizico-react-promise">
                <svg height="32" viewBox="0 0 16 16" version="1.1" width="32">
                  <path fillRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                </svg>
              </a>
            </div>
            <Menu theme="dark" mode="inline">
              {/* <MenuItem key="1" path="/" label="README" exact /> */}
              <MenuItem key="2" path="/base-query" label="Base Query" exact />
              <MenuItem key="3" path="/base-manipulation" label="Base Manipulation" exact />
              <MenuItem key="4" path="/manipulation-loaders" label="Manipulation Loaders" exact />
              <MenuItem key="5" path="/list" label="List" exact />
              <MenuItem key="6" path="/list-hooks" label="List (hooks)" exact />
            </Menu>
          </Sider>
          <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ margin: '24px 16px 0' }}>
              <Switch>
                {/* <Route exact path="/" component={Readme} /> */}
                <Route exact path="/base-query" component={BaseQueryExample} />
                <Route exact path="/base-manipulation" component={BaseManipulationExample} />
                <Route exact path="/manipulation-loaders" component={ManipulationLoadersExample} />
                <Route exact path="/list" component={ListExample} />
                <Route exact path="/list-hooks" component={ListHooksExample} />
                <Route exact path="/example" component={Example} />
                <Redirect to="/base-query" />
              </Switch>
            </Content>
            <Footer style={{ textAlign: 'center' }}>
              Created by Bizico
            </Footer>
          </Layout>
        </Layout>
      </HashRouter>
    );
  }
}

export default App;
